import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { Permissions } from "shared/model/AllPermissions";
import { ThunkResult, Utilities } from "../../shared/utilities";
import { receiveTasks } from "../actions/FetchDataItems";
import { IAction, IReceiveErrorAction } from "../model/IAction";
import { IElement, IProcessData } from "../model/IProcessData";
import { State } from "../model/State";
import { restoredFromLocalStorageOk } from "./ProcessToLocalStorageActions";
import { receiveProcessVariables } from "./ProcessVariableActions";

const processResponse = (dispatch: ThunkDispatch<State, null, Action<any>>, data: any, isEditorReadOnly: boolean, wasRestored: boolean) => {
    document.title = `${data.name} - v.${data.majorVersion}.${data.minorVersion}.${data.version}${isEditorReadOnly ? ` (read-only)` : ""}`;
    dispatch(receiveProcess(data));
    dispatch(receiveProcessVariables(data.processVariables ?? []));
    dispatch(receiveTasks(data.obsoleteTasks ?? []));
    if (wasRestored) {
        dispatch(restoredFromLocalStorageOk());
    }
    return data.elementParameters;
};

const getProcessData = async (dataOrFetchUri: IProcessData | string): Promise<[boolean, IProcessData]> => {
    if (typeof dataOrFetchUri === "string") {
        const fetchUri = dataOrFetchUri as string;
        const data = await Utilities.getFetch<IProcessData>(fetchUri);
 
        return [false, data];
    }

    return [true, dataOrFetchUri as IProcessData];
};

export function fetchProcess(dataOrFetchUri: IProcessData | string): ThunkResult<Promise<IElement[]>, State> {
    return async (dispatch) => {
        dispatch(requestProcess());
        const [wasRestored, data] = await getProcessData(dataOrFetchUri);
        const isEditorReadOnly = !Utilities.getUserPermission(Permissions.ProcessEdit);
        return processResponse(dispatch, data, isEditorReadOnly, wasRestored);
    };
}

export const REQUEST_PROCESS = "REQUEST_PROCESS";
function requestProcess() {
    return {
        type: REQUEST_PROCESS
    };
}

export const RECEIVE_PROCESS = "RECEIVE_PROCESS";
function receiveProcess(data: IProcessData) {
    return {
        type: RECEIVE_PROCESS,
        processData: data
    } as IReceiveProcessAction;
}

export const RECEIVE_PROCESS_ERROR = "RECEIVE_PROCESS_ERROR";
export function receiveProcessError(error: string) {
    return {
        type: RECEIVE_PROCESS_ERROR,
        error: error
    } as IReceiveErrorAction;
}

export interface IReceiveProcessAction extends IAction {
    processData: IProcessData;
}
